// Benchmarking lícito: comparación de funcionalidades públicas observables de
// plataformas reales del mercado chileno de transferencia vehicular.
// value: 2 = completo, 1 = parcial/observable, 0 = no observable públicamente.
// Competidores reales con mayor volumen de transferencias en Chile (info pública 2026):
// Autofact, Dily y AutoTransfiere.
export const COMPETITORS = ["Transfiérelo", "Autofact", "Dily", "AutoTransfiere"];

export const COMPARISON = [
  { feature: "Transferencia Exprés con plazo definido (72 h)", values: [2, 1, 1, 0], note: true },
  { feature: "Consulta gratis por patente, sin registro", values: [2, 0, 0, 0] },
  { feature: "Simulador de costos transparente e itemizado", values: [2, 1, 1, 1] },
  { feature: "Transferencia 100% digital", values: [2, 2, 2, 2] },
  { feature: "Validación biométrica + prueba de vida", values: [2, 2, 1, 1], note: true },
  { feature: "Firma electrónica avanzada (Ley 19.799)", values: [2, 2, 2, 2], note: true },
  { feature: "Informe vehicular propio (40+ datos)", values: [2, 2, 1, 0] },
  { feature: "Historial: dueños, km, revisiones y siniestros", values: [2, 2, 1, 0] },
  { feature: "Verificación pública del informe (QR + sello)", values: [2, 0, 0, 0] },
  { feature: "Folio de Pre-Ingreso para acelerar la inscripción", values: [2, 0, 0, 0] },
  { feature: "Motor de riesgo con scoring verde/amarillo/rojo", values: [2, 1, 0, 0] },
  { feature: "IA documental: detecta inconsistencias y faltantes", values: [2, 0, 0, 0] },
  { feature: "Tasador de mercado real (publicaciones vigentes)", values: [2, 1, 1, 0] },
  { feature: "Todos los tipos de contrato (empresa, leasing, sucesión…)", values: [2, 1, 1, 0] },
  { feature: "Panel dedicado de Notaría", values: [2, 0, 0, 0] },
  { feature: "Panel de Automotora / concesionario", values: [2, 2, 1, 1] },
  { feature: "Panel de administración con métricas y auditoría", values: [2, 1, 1, 1] },
  { feature: "Trazabilidad + evidencia (hash, IP, dispositivo)", values: [2, 1, 1, 0] },
  { feature: "Cumplimiento de datos (Ley 19.628 / 21.719)", values: [2, 1, 1, 1] },
  { feature: "Contrato + anexos automáticos (consentimiento, acta…)", values: [2, 1, 1, 1] },
  { feature: "API, Webhooks y Marca blanca", values: [2, 1, 0, 0] },
];

// Contexto de velocidad para la franja del hero (información pública; los tiempos de
// inscripción definitiva dependen del Registro Civil y pueden variar).
export const MARKET_SPEED = [
  { name: "Transfiérelo Exprés", time: "72 horas", highlight: true },
  { name: "Plataformas digitales actuales", time: "15 a 25 días*" },
  { name: "Trámite tradicional (Registro Civil / notaría)", time: "30 a 40 días" },
];

export const UNIQUE_ADVANTAGES = [
  { title: "Transferencia Exprés en 72 horas", desc: "Nuestro mayor diferenciador: expediente completo, validado y listo para inscripción en 72 horas, no semanas." },
  { title: "Informe Transfiérelo 360 (el más completo)", desc: "40+ datos: historial de dueños, kilometraje, revisiones técnicas, siniestros, deuda TAG, ficha técnica y semáforo de riesgo. Supera al informe de Autofact." },
  { title: "Folio de Pre-Ingreso propio", desc: "Valida y arma el expediente con QR y sello para que la inscripción oficial sea inmediata y sin rebotes — exclusivo de Transfiérelo." },
  { title: "Motor de riesgo transparente", desc: "Scoring con 15+ variables y semáforo verde/amarillo/rojo en cada operación." },
  { title: "IA documental (Claude)", desc: "Detecta inconsistencias y documentos faltantes; genera resúmenes jurídicos." },
  { title: "Panel de Notaría + verificación pública", desc: "Bandeja con evidencia, firma y verificación pública del informe por QR — certeza jurídica trazable." },
  { title: "Consulta gratis por patente", desc: "Semáforo de riesgo al instante y sin registro: el mejor gancho de captación." },
  { title: "Compliance por diseño", desc: "Ley 19.628, 21.719 y 19.799, consentimiento, derechos ARCO y auditoría integral." },
];
